import { render, staticRenderFns } from "./EstimatedShipping.vue?vue&type=template&id=673b2db7&"
import script from "./EstimatedShipping.vue?vue&type=script&lang=js&"
export * from "./EstimatedShipping.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {OpusIcon: require('/~/src/modules/opus/components/Icon.vue').default})
